// extracted by css-extract-rspack-plugin
export default {"root":"root-t4gdpx","resultsCount":"resultsCount-fCMoiU","banner":"banner-CCOXQI"};